export function getRelatedItems(mapItem: any, previewItems: any[]) {
  let mapItems = previewItems.map((item: any) => {
    let [dimStr, agg, _] = item.filename.split(".");
    let dimList = dimStr.split("__");
    let F = !item.filter ? null : Object.entries(item.filter);
    return [
      agg, 
      dimList[0], 
      dimList?.[1] || null, 
      !F ? null : `${F[0][0]}__${F[0][1]}`, 
      !F || F.length < 2 ? null : `${F[1][0]}__${F[1][1]}`
    ]
  });

  let filterItems = mapItems.filter((item: any) => diff(item, mapItem) === 1);
  let s = selectable(filterItems, mapItem);

  return s;
}

export function getMapItem(filename: string, filter: string) {
  let [dimStr, agg_, _] = filename.split(".");
  let dimList = dimStr.split("__");
  let G = !filter ? null : filter?.split("__")
    .reduce((acc: any[], cur: string, index: number) => {
      if (index % 2 === 0) {
        acc.push(`${cur}__`);
      } else {
        acc[acc.length - 1] = acc[acc.length - 1] + cur;
      }
      return acc;
    }, []);
  let mapItem = [
    agg_,
    dimList[0], 
    dimList?.[1] || null, 
    !G ? null : G[0], 
    !G || G.length < 2 ? null : G[1]
  ];
  return mapItem
}

function diff(a: any, b: any) {
  let count = a.map((i: any, index: number) => (i === b[index] ? 0 : 1))
               .reduce((acc: number, cur: number) => acc + cur, 0);
  return count
}

function selectable(filterItems: any[], mapCur: any) {
  let output: [any[], any[], any[], any[], any[]] = 
    [[mapCur[0]], [mapCur[1]], [mapCur[2]], [mapCur[3]], [mapCur[4]]];
  for (const mapItem of filterItems) {
    for (var i = 0; i < 5; i++) {
      if (mapCur[i] !== mapItem[i]) {
        output[i].push(mapItem[i]);
      }
    }
  }
  return output.map((items: any) => items.sort());
}
